import React, { Component } from "react";
import {
  RaisedButton,
  RefreshIndicator,
  Paper,
  Divider,
  SelectField,
  MenuItem,
  Snackbar,
} from "material-ui";

const style = {
  container: {
    position: "relative",
  },
  refresh: {
    display: "inline-block",
    position: "relative",
  },
};
const LoadingIndicator = () => (
  <RefreshIndicator
    size={60}
    left={70}
    top={0}
    loadingColor="#FF9800"
    status="loading"
    style={style.refresh}
  />
);

export default class ReportGenerator extends Component {
  state = {
    showLayer: false,
    showSnackbar: false,
    loading: false,
    documentType: "",
    documentLink: "",
  };

  getStyles() {
    return {
      center: {
        textAlign: "center",
      },
      paper: {
        width: "96%",
        margin: 30,
        textAlign: "center",
      },
      refresh: {
        display: "inline-block",
        position: "relative",
      },
    };
  }

  render() {
    let { showLayer, documentType, loading, showSnackbar, documentLink } =
      this.state;
    let { paper, center, refresh } = this.getStyles();

    return (
      <Paper zDepth={3} style={paper}>
        <h3>Report Generator</h3>
        <br />
        <Divider />

        <RaisedButton
          label="8879 Reports"
          primary={true}
          onTouchTap={this.genEfileReports}
        />
      </Paper>
    );
  }

  genEfileReports = () => {
    let url = "/api/reports/e-file";
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ loading: false, showSnackbar: true });
      });
  };
}



// WEBPACK FOOTER //
// ./app/components/reports/ReportGenerator.js